const userInfoPlugin = store => {
  store.subscribe(mutation => {
    if (mutation.type === "schoolAuth/clearSchoolAuth") {
      return store.dispatch("user/ClearUserInfo");
    }

    // if (mutation.type === "user/setUserInfo") {
    //   console.log("UPDATE USER: ", store);
    // }
  });
};

export default userInfoPlugin;
